import axios from "../index"

/**
 * 注册
 * userName  手机账号
 * password  密码
 * typeId 所属馆
 * telCode 手机验证码
 * @returns {*}
 */
export function register(params) {
  return axios.post('/portal/reader/register', params)
}

/**
 * 手机验证
 * imageVerification  图形验证码
 * tel    手机号
 * @returns {*}
 */
export function telVerification(params) {
  return axios.post('/portal/reader/telVerification', params)
}

/**
 * 登录
 * userName  手机账号
 * password  密码
 * imageVerification 图形验证码
 * @returns {*}
 */
export function loginByImg(params) {
  return axios.post('/portal/reader/loginByImg', params)
}

/**
 * IP白名单 判断
 * @param params
 * @returns {*}
 * typeId  是  Long  所属馆id，0：查询所有
 * ipType  是  Integer  ip类型 1：公网；2：内网
 * ip  是  String  ip
 */
export function getIntranet(params) {
  return axios.post('/portal/intranet/validQuery', params)
}

/**
 * 找回密码
 * @param params
 * @returns {*}
 * userName  是  Long  所属馆id，0：查询所有
 * password  是  Integer  ip类型 1：公网；2：内网
 * telCode  是  String  ip
 * tel
 * imageVerification
 */
export function getPasswordById(params) {
  return axios.post('/portal/reader/getPasswordById', params)
}
